jQuery(document).ready(function ($) {
  document.addEventListener("DOMContentLoaded", function () {
    // Check if the user is logged in and if a specific cookie is set.
    if (
      document.querySelector(".customer-logged-in") &&
      !getCookie("first_login_redirect")
    ) {
      // Set a cookie to indicate that the user has logged in.
      document.cookie =
        "first_login_redirect=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";

      // Redirect to the account page. Replace '/account' with the actual URL of your account page.
      window.location.href = "/account";
    }
  });
  if ($(window).width() < 767) {
    jQuery(".slider-mobile-gutter .collection__inner.product-grid").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }

  function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  /* Home Collection Slider */
  $('[target="blank"]').attr("aria-label", "open in a new tab");
  $(".collection_list_main li").slice(0, 12).show();
  if ($(".collection_list_main li:hidden").length != 0) {
    $("#load_more_collection").show();
  }

  $(".blog-articles__article").slice(0, 5).show();
  if ($(".blog-articles__article:hidden").length != 0) {
    $("#load").show();
  }

  $("#load_more_collection").on("click", function (e) {
    e.preventDefault();
    $(".collection_list_main li:hidden").slice(0, 6).slideDown();
    if ($(".collection_list_main li:hidden").length == 0) {
      $("#load_more_collection").hide();
    }
  });

  // setTimeout(function () {
  //   if($('span').hasClass('mw-option__price')){
  //     var name = $('.mw-option__price').text();
  //     $('.engraving.flexnowrap label').text('Add Engraving '+name);
  //   }
  // }, 500);
  var triggeronce = true;
  jQuery(".addToCart").on("click", function (e) {
    if (!jQuery("div").hasClass("hidden_class_show")) {
      if (jQuery("div").hasClass("engraving")) {
        e.preventDefault();

        // console.log('check click button');
        // var check = '';
        // var text = '';
        // if(jQuery("#e__checkbox").prop("checked") == true) {
        //     var custom_text = jQuery(".mw-option__control").val();
        //     if(custom_text != ''){
        //       check = 'find';
        //     }else{
        //       alert('Please enter engraving text.');
        //       return false;
        //     }
        // }else{
        //     alert('Please checked engraving option.');
        //     return false;
        // }

        // var custom_text = jQuery(".mw-option__control").val();
        // if(custom_text != ''){
        //     if (jQuery("#e__checkbox").prop("checked") == false) {
        //          alert('Please click on checkbox value.');
        //          return false;
        //     }else{
        //        text = 'find';
        //     }
        // }else{
        //     alert('Please enter engraving text.');
        //     return false;
        // }

        // if(check != '' && text != ''){
        setTimeout(() => {
          $('.product-form__buttons button[type="submit"]').trigger("click");
        }, 400);

        // }
      } else {
        // setTimeout(()=>{
        //   $('.product-form__buttons button[type="submit"]').trigger('click');
        //   return FALSE;
        // },400);
      }
    } else {
      if (triggeronce) {
        $('.product-form__buttons button[type="submit"]').trigger("click");
        triggeronce = false;
        return FALSE;
      }
    }
  });

  // This code will run after the registration form is successfully submitted.
  jQuery(document).on("submit", "form.create_customer", function (event) {
    event.preventDefault(); // Prevent the default form submission.
    alert("User account created successfully!");
    window.location.href = "/account"; // Redirect to the account page.
  });
  // jQuery(".product-form__submit").click(function (e) {

  //   if (jQuery("#engraving_check").prop("checked") == true) {
  //     var custom_text = jQuery("#e__text").val();
  //     jQuery("#engraving").val(custom_text);
  //   } else {
  //     jQuery(".mw-option__control").val("");
  //   }

  // });

  // $("#e__text").keyup(function(){

  //   if (jQuery("#e__checkbox").prop("checked") == true) {
  //       var custom_text = jQuery("#e__text").val();
  //       jQuery("#engraving").val(custom_text).trigger( "change" );
  //   }else{
  //       jQuery("#engraving").val("");
  //   }
  //   $('.mw-option__value').addClass('mw-option__value--selected');
  //   $('.mw-option__control').first().focus();

  // });

  // let cloneTxt = document.querySelector('#e__text');
  //       let button = document.querySelector('.product-form__submit');
  //       cloneTxt.addEventListener('change',()=>{
  //           let clone = document.querySelector('#e__text').value;
  //           document.querySelector('.mw-option__control').value = clone;
  //       });
  //       button.addEventListener('click',()=>{
  //           let checkval = document.querySelector('.mw-option__control').value;
  //           console.log(checkval);
  //       });

  jQuery("#e__checkbox").click(function () {
    if (jQuery(this).prop("checked") == true) {
      // jQuery(".mw-option__control").prop("checked", true).triggerHandler( "change" );
      // jQuery("#engraving_check").prop("checked", true);
      jQuery(".mw-option__control").prop("disabled", false);
    } else if (jQuery(this).prop("checked") == false) {
      // jQuery("#engraving_check").prop("checked", false).triggerHandler( "change" );
      // jQuery(".mw-option__control").prop("checked", false);
      jQuery(".mw-option__control").prop("disabled", true);
    }
  });

  $(".popup__close").on("click", function (e) {
    e.preventDefault();
    $(".upsell_popup").removeClass("active");
    $("body").removeClass("fixed");
  });

  $("#load").on("click", function (e) {
    e.preventDefault();
    $(".blog-articles__article:hidden").slice(0, 4).slideDown();
    if ($(".blog-articles__article:hidden").length == 0) {
      $("#load").hide();
    }
  });

  setInterval(function () {
    if ($("div").hasClass("upsell-slider")) {
      if ($("body").hasClass("fixed")) {
        if (!$(".upcell_listing ").hasClass("slick-slider")) {
          $(".upcell_listing product-recommendations.related-products").slick({
            dots: false,
            infinite: true,
            speed: 300,
            autoplay: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            prevArrow: $(".upsell__arrow--left"),
            nextArrow: $(".upsell__arrow--right"),
          });
        }
      }
    }
  }, 200);

  if ($("div").hasClass("collection_slider")) {
    $(".collection_slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
    });
  }

  $(".media-slider").slick({
    dots: true,
    arrows: true,
    infinite: true,
    speed: 300,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  if ($("div").hasClass("logo__inner")) {
    $(".logo__inner").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 481,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            autoplay: true,
            autoplaySpeed: 2000,
          },
        },
      ],
    });
  }

  if ($("div").hasClass("announcement-main")) {
    $(".announcement-main").on("init", function () {
      $(".announcement-main").css({ visibility: "visible" });
    });
    $(".announcement-main").slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      fade: true,
      cssEase: 'linear',
      adaptiveHeight: true
    });
  }

  $(".btn__close").on("click", function (e) {
    e.preventDefault();
    $(".tm-pop").removeClass("active");
    $("body").removeClass("fixed");
  });

  $(".tm-pop__heading").on("click", function () {
    console.log(this);
    $(".tm-pop__heading").removeClass("active");
    $(this).not(".active").addClass("active");
  });

  $(".team_pop").on("click", function (e) {
    e.preventDefault();
    // alert("sfdsfdsfds");
    $(".tm-pop").addClass("active");
    var dataid = $(this).attr("dataid");
    var next_auth = ++dataid;
    // alert(next_auth);
    var dataid = $(this).attr("dataid");
    $(".tm-pop-button").attr("dataid", next_auth);
    var name = $(".auth_next_" + next_auth).text();
    if (name == "") {
      next_auth = 1;
      $(".tm-pop-button").attr("dataid", next_auth);
      var name = $(".auth_next_" + next_auth).text();
    }
    // alert(name);
    $(".name_auth").text(name);
    $(".tm-pop__media").hide();
    $(".tm-pop__description").hide();
    $(".show_" + dataid).show();
    $("body").addClass("fixed");
  });

  $(".tm-pop-button").on("click", function (e) {
    e.preventDefault();
    //$('.tm-pop').addClass('active');
    var dataid = $(this).attr("dataid");
    var next_auth = ++dataid;

    // alert(next_auth);
    var dataid = $(this).attr("dataid");
    $(".tm-pop-button").attr("dataid", next_auth);
    var name = $(".auth_next_" + next_auth).text();
    if (name == "") {
      next_auth = 1;
      $(".tm-pop-button").attr("dataid", next_auth);
      var name = $(".auth_next_" + next_auth).text();
    }
    // alert(name);
    $(".name_auth").text(name);
    $(".tm-pop__media").hide();
    $(".tm-pop__description").hide();
    $(".show_" + dataid).show();
  });
});
